import { z } from 'zod';
import { coproductionSchema } from './coproduction';
import { Product } from './product';
import {
  validateAffiliationEmail,
  validateAffiliationPixKey,
} from '@api/affiliation';
import { ExternalValidationFunction } from '@interfaces/externalValidationResolver';

export const affiliationSchema = coproductionSchema.extend({
  type: z.string(),
});
export type Affiliation = z.infer<typeof affiliationSchema> & {
  affiliationCode: string;
  botConfig: Pick<Product, 'name'>;
};

export const createAffiliationFormSchema = affiliationSchema.omit({
  id: true,
});
export type CreateAffiliationForm = z.infer<typeof createAffiliationFormSchema>;

export const updateAffiliationSchema = z.object({
  pix: z.string().trim().nonempty('A chave pix é obrigatória'),
});
export type UpdateAffiliationSchema = z.infer<typeof updateAffiliationSchema>;

export type validateAffiliationEmailDto = Pick<CreateAffiliationForm, 'email'>;

export type ValidateAffiliationEmailResponse = {
  success: boolean;
  userId?: number;
};

export const isAffiliationEmailValid =
  (productId: Product['id']): ExternalValidationFunction =>
  async (email) => {
    const { success } = await validateAffiliationEmail(productId, {
      email: email as string,
    });

    return {
      success,
      errorMessage: 'Este usuário não é elegível para afiliação.',
    };
  };

export type validateAffiliationPixKeyDto = {
  pix: string;
};
export type ValidateAffiliationPixKeyResponse = {
  success: boolean;
  msg: string;
};

export const isAffiliationPixKeyValid =
  (productId: Product['id']): ExternalValidationFunction =>
  async (pix) => {
    const { success, msg: errorMessage } = await validateAffiliationPixKey(
      productId,
      {
        pix: pix as string,
      },
    );
    return { success, errorMessage };
  };

export type AffiliationFilters = {
  botConfigIds: Affiliation['botConfigId'][];
};

export type AffiliatedCommunity = {
  id: Affiliation['id'];
  commissionRate: Affiliation['commissionRate'];
  salesUrl: string;
  botConfig: Pick<Product, 'id' | 'name' | 'supportContact'>;
  pix: Affiliation['pix'];
};
